import { useTranslation } from 'react-i18next'
import { ConfidentialRecordMenuItem } from '@omnea-app/fe-authz/ConfidentialRecordMenuItem'
import { type InheritedParent } from '@omnea-app/fe-authz/inheritedConfidentiality'
import { DOCUMENT_LIST_QUERY_KEYS } from '@omnea-app/fe-documents/documentListQueryKeys'
import { RequestDetailQueryKey } from '../../../../useRequestDetail'
import { MarkRequestConfidentialDialog } from './MarkRequestConfidentialDialog'

type Props = {
  requestId: string
  isConfidential: boolean | undefined
  inheritedFrom: readonly InheritedParent[] | undefined
  onClose?: () => void
}

export const ConfidentialMenuItem = ({ requestId, isConfidential, inheritedFrom, onClose }: Props) => {
  const { t } = useTranslation('requests')

  if (isConfidential == null || inheritedFrom == null) return null

  return (
    <ConfidentialRecordMenuItem
      entity="request"
      recordId={requestId}
      isConfidential={isConfidential}
      inheritedFrom={inheritedFrom}
      permission="canAdminister"
      invalidateKeys={[[RequestDetailQueryKey, requestId], ...DOCUMENT_LIST_QUERY_KEYS]}
      onClose={onClose}
      translateCopy={(key) => t(`confidentiality.${key}`)}
      labels={{ mark: t('manage-request.mark-confidential'), unmark: t('manage-request.unmark-confidential') }}
      renderMarkDialog={(close, bodyTexts) => (
        <MarkRequestConfidentialDialog requestId={requestId} bodyTexts={bodyTexts} onClose={close} />
      )}
    />
  )
}
